import { useEffect, useState } from '@biletiniz/ui-core';
import { useMutation } from '@biletiniz/apollo';
import { LOGIN_CONFIRM } from './gql/login-confirm';

export const useLoginConfirm = () => {
  const [localData, setLocalData] = useState(false);

  const [useLoginConfirmMutation, { error, loading }] = useMutation(
    LOGIN_CONFIRM,
    {
      onCompleted: setLocalData,
    }
  );
  const [loaded, setLoaded] = useState(false);
  const LoginConfirm = loginConfirmInfo => {
    return useLoginConfirmMutation({
      variables: loginConfirmInfo,
    });
  };
  useEffect(() => {
    if (localData && !loaded) {
      setLoaded(true);
    }
  }, [localData]);

  const initialValues = {
    confirm: '',
  };

  return {
    localData,
    setLocalData,
    loaded,
    error: error?.message,
    LoginConfirm,
    loading,
    initialValues,
  };
};
